export const LOADER_FINISHED = 'LOADER_FINISHED';
export const LOADER_STARTED = 'LOADER_STARTED';
